// extracted by css-extract-rspack-plugin
export default {"container":"Wn9Yy","center":"hHpvG","img":"jlcVs","texts":"hkQFP","buttons":"ARfaN","button_override":"dnz3V","buttonOverride":"dnz3V","#":"QOCx0"};